module.exports = __webpack_public_path__ + "img/photo-album-test-02.e3aaaa56.png";